import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useNewsBriefing } from '@/pages/NewsBriefing/_context/NewsContext';
import useWebview from '@/hooks/V3/useWebview';
import { useAppSelector } from '@/redux/store';

export const useSubmitNewsFeedback = () => {
  const { data } = useNewsBriefing();
  const { group } = useParams<{ group: string }>();
  const { UserNo } = useAppSelector((state) => state.user);
  const { postMessage } = useWebview();
  const navigate = useNavigate();
  const location = useLocation();

  const date = data?.date || new Date().toISOString();

  const submitFeedback = (message: 'satisfying' | 'disappointing') => {
    const formattedDate = date.slice(0, 10);

    const payload = {
      date: formattedDate,
      group,
      message,
      userId: UserNo,
    };

    postMessage({
      action: 'saveAsyncStorage',
      data: {
        newsBriefing_evaluation: JSON.stringify(payload),
      },
    });

    const params = new URLSearchParams(location.search);
    params.set('newsEvaluation', message);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  return { submitFeedback };
};
